/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LoginEmail/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function LoginEmail({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/PracticeHub/People/Person/LoginEmail"
  
}) {
let personPublicUserAccountEmailValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'public_user.account.email',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="person.public_user.account.email"
 text={personPublicUserAccountEmailValueData}
/>
{children}
</React.Fragment>)
}